declare const vLoadingDirective: {
    mounted(el: HTMLElement, binding: {
        value: any;
    }): void;
    updated(el: HTMLElement, binding: {
        value: any;
    }): void;
    unmounted(el: HTMLElement, _binding: any): void;
};
export default vLoadingDirective;
